export enum recruitmentsPublicListTypes {
  FETCH_RECRUITMENTS_PUBLIC_LIST_REQUEST = "FETCH_RECRUITMENTS_PUBLIC_LIST_REQUEST",
  FETCH_RECRUITMENTS_PUBLIC_LIST_SUCCESS = "FETCH_RECRUITMENTS_PUBLIC_LIST_SUCCESS",
  FETCH_RECRUITMENTS_PUBLIC_LIST_FAILURE = "FETCH_RECRUITMENTS_PUBLIC_LIST_FAILURE",
}